import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentPage: 'home', // Название страницы
    currentPageId: 0     // Идентификатор страницы
};

const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
        setPage: (state, action) => {
            // Ожидаем объект с полями `id` и `name`
            state.currentPage = action.payload.name;
            state.currentPageId = action.payload.id;
        },
    },
});

export const { setPage } = pageSlice.actions;

export default pageSlice.reducer;
